import { Component } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import { Router } from '@angular/router';
import { AppService } from '../../service/app.service';
import { Utente } from '../../interfaces/user';
import { CommonModule } from '@angular/common';
import { AnagraficaEnte } from '../../interfaces/anagrafica-ente.interface';
import { ItButtonDirective, ItCardComponent, ItIconComponent } from 'design-angular-kit';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InformativaPrivacyComponent } from "./informativa-privacy.component";
import { Subscription } from 'rxjs';
import { UtentiMasterService } from '../utenti-master/utenti-master.service';
import { appsettingsConfig } from '../../../main';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [CommonModule, ItCardComponent, ItButtonDirective, ReactiveFormsModule, ItIconComponent, InformativaPrivacyComponent],
  templateUrl: './privacy.component.html',
})
export class PrivacyComponent {
  constructor(
    private loader: LoaderService,
    private router: Router,
    private appService: AppService,
    private utentiMasterService: UtentiMasterService,
  ) {}

  utente: Utente = {};
  ente: AnagraficaEnte = {};
  urlRegolamento = appsettingsConfig?.urlRegolamento;
  scrollObserve: IntersectionObserver | undefined;
  form = new FormGroup({
    privacy: new FormControl({ value: false, disabled: true }, Validators.requiredTrue)
  });
  enti: AnagraficaEnte[] = [];
  pageSubscription = new Subscription();

  ngOnInit(): void {
    this.utente = this.appService.user;
    this.ente = this.appService.ente;
    this.loader.hide();
  }

  ngAfterViewInit(): void {
    this.scrollObserve = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.form.get('privacy')?.enable();
        }
      })
    });
    const target: any = document.querySelector('#endPrivacy');
    this.scrollObserve.observe(target);
  }

  redirect(url: string) {
    this.router.navigate([url]);
  }

  save(): void {
    if (this.form.invalid) {
      return;
    }
    this.loader.show();
    this.pageSubscription.add(
      this.utentiMasterService.privacy(this.utente.idUtenteMaster ?? 0, this.utente).subscribe({
        next: () => {
          this.utente.flagPrivacy = true;
          this.redirect('/home')
        },
        error: () => {
          this.loader.hide();
        },
        complete: () => this.loader.hide(),
    }));
  }

  ngOnDestroy(): void {
    if (this.scrollObserve) {
      this.scrollObserve?.disconnect();
    }
    this.pageSubscription.unsubscribe();
  }
}
